import LogNames from 'txp-data/lib/schema/telemetry/LogNames';
import CardItem from 'txp-data/lib/schema/viewSchema/CardItem';

/**
 * populate the Expand card dataPoint object
 */
export default function populateExpandActionDataPoint(cardItem: CardItem, isExpanded: boolean) {
    return {
        [LogNames.entityNamesFlag]: cardItem.entityType.toString(),
        [LogNames.isExpanded]: isExpanded.toString(),
        [LogNames.activityType]: cardItem.activityType.toString(),
    };
}
